import styles from './PollCardSkeleton.module.css';

export function PollCardSkeleton() {
    return (
        <div className={styles.card}>
            {/* Header skeleton */}
            <div className={styles.header}>
                <div className={`${styles.shimmer} ${styles.avatar}`} />
                <div className={`${styles.shimmer} ${styles.name}`} />
                <div className={`${styles.shimmer} ${styles.time}`} />
            </div>

            {/* Title skeleton */}
            <div className={`${styles.shimmer} ${styles.titleLine}`} />
            <div className={`${styles.shimmer} ${styles.titleLineShort}`} />

            {/* Options skeleton */}
            <div className={styles.optionsBox}>
                <div className={`${styles.shimmer} ${styles.optionBar}`} />
                <div className={`${styles.shimmer} ${styles.optionBar}`} />
            </div>

            {/* Action bar skeleton */}
            <div className={styles.actionBar}>
                <div className={`${styles.shimmer} ${styles.actionItem}`} />
                <div className={`${styles.shimmer} ${styles.actionItem}`} />
                <div className={`${styles.shimmer} ${styles.actionItemRight}`} />
            </div>
        </div>
    );
}
